import { UniqueFeatureName } from './types';

const ExperimentUniqFeatureNames = {
  grow_2529_create_limit: ['grow_2529_survey_create_limit', 'grow_2529_unlimited_forms'],
  grow_2529_unlimited_questions: ['grow_2529_forms_unlimited_questions', 'grow_2529_unlimited_questions'],
  grow_2529_question_types: ['grow_2529_question_types', 'grow_2529_forms_question_types'],
  grow_2529_analysis_filter: ['grow_2529_analysis_filter', 'grow_2529_forms_analysis_filter'],
  grow_2792_user: [
    'grow_2792_single_user',
    'grow_2792_team_collaboration_user',
    'grow_2792_advanced_team_collaboration_user',
  ],
  grow_2792_question_types: ['grow_2792_forms_question_types', 'grow_2792_all_question_types'],
  grow_2792_survey_branding: ['grow_2792_create_custom_theme_enabled', 'survey_branding'],
};

const uniqueFeatureNameMap: UniqueFeatureName = {
  contributor_seats: ['contributor_seats', 'advanced_collaboration'],
  response_count: ['base_response_count', 'unlimited_responses', 'num_free_responses'],
  support: ['priority_email_support', 'phone_support', 'email_support', 'grow_2529_phone_support'],
  skip_logic: ['create_piping_enabled', 'skip_logic'],
  statistical_significance: ['statistical_significance', 'text_analysis'],

  // ExperimentUniqFeatureNames should always be last
  ...ExperimentUniqFeatureNames,
};

export default uniqueFeatureNameMap;
